import React, { useEffect } from 'react'
import { AppDispatch, RootState } from '../../redux-stores/store';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountDeletionRequestsThunk } from '../../redux-stores/slices/influencerSlice';
import { requestAccountDeletion } from '../../services/api/influencer';

const AccountDeletion = () => {
    const [loading, setLoading] = React.useState(false);
    const accountDeletionRequestsData = useSelector((state: RootState) => state.influencer.accountDeletionRequests);
    const accountDeletionRequests = accountDeletionRequestsData.items ?? [];
    const fetchingAccountDeletionRequests = accountDeletionRequestsData.loading;

    const dispatch:AppDispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAccountDeletionRequestsThunk({}));
    }, [dispatch]);

    const requestDeletion = async () => {
        setLoading(true);
        try {
            await requestAccountDeletion();
            dispatch(fetchAccountDeletionRequestsThunk({force: true}));
        } catch (error) {
            console.error("Failed to request account deletion:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <div className="d-flex flex-column gap-075">
                <h4 className="new-slide-up-modal-heading mt-2 mb-0">Request Account Deletion</h4>
                <span className="new-slide-up-modal-desc">
                    Request to permanently delete your account and all associated data.
                </span>
            </div>
            <hr />
            <div className="">
                <div className="d-flex flex-column gap-2 mb-3">
                    {
                        accountDeletionRequests.map((request, index) => (
                            <div key={index} className="border rounded-3 p-2">
                                <div>
                                    <b>Request Date:</b> {request.created}
                                </div>
                                <div>
                                    <b>Status:</b> <span className={`fw-bold ${request.status === 'pending' ? 'text-warning' : (request.status === 'rejected' ? 'text-danger' : '')}`}>{request.status.toUpperCase()}</span>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className="alert alert-info">
                    If you have active collaborations, please complete them before requesting account deletion.
                </div>
                <hr />
                <h6>What Happens After You Request Deletion?</h6>
                <ul>
                    <li>Your account will be reviewed to ensure there are no active collaborations.</li>
                    <li>Once verified, your account will be permanently deleted within <b className='p-0'>7 days</b>.</li>
                    <li>All personal information associated with your account will be removed.</li>
                    <li>You will receive an email confirmation once deletion is complete.</li>
                </ul>

            </div>

            {/* Save Changes Button */}
            <div className="campaign-apply-ig-connect-benefit-actions pb-5">
                <button disabled={accountDeletionRequests.length > 0 || loading || fetchingAccountDeletionRequests} onClick={requestDeletion} className="new-ui-btn">{fetchingAccountDeletionRequests ? 'Please wait...' : 'Request Deletion'}</button>
            </div>
        </div>
    )
}

export default AccountDeletion
